import { AssetLocationMeasurement } from "../models/asset-location-measurement";

export class AssetTrackingHeader {
	parent: any;
	async bind(bindingContext: any, overrideContext: any) {
		this.parent = bindingContext;
	}
}